export const articlesPath = "/articles/";
export const articleUrl = (id: string) => `${articlesPath}${encodeURIComponent(id)}`;
